import React from 'react';
import {useIntl} from "react-intl";
import dayjs from "dayjs";
import {VisitRequestDto} from "../../../modules/vms/dto/VisitRequestDto";
import {DictItemDto} from "../../../modules/dict/dto/DictItemDto";
import {StatusType} from "../../../modules/vms/enums/StatusType";
import {Formats} from "../../../constants/Formats";
import DictItemUtils from "../../../modules/dict/utils/DictItemUtils";
import EnumItemLabel from "../../../components/EnumItemLabel";
import {ApplySourceType} from "../../../modules/vms/enums/ApplySourceType";
import Descriptions from "../../../components/Descriptions";
import DescriptionItem from "../../../components/DescriptionItem";
import {Card, CardContent, CardHeader} from "@mui/material";

export type VisitRequestHostInfoProps = {
    visitRequest: VisitRequestDto;
    purposeTypes: Array<DictItemDto>;
    employeeEntityTypes: Array<DictItemDto>;

};

const VisitRequestHostInfo: React.FC<VisitRequestHostInfoProps> = (props) => {
    const intl = useIntl();

    let hostName2 = "";
    let hostDepartmentName2 = "";
    let host2Json;
    if (props.visitRequest && props.visitRequest.remarks) {
        host2Json = JSON.parse(props.visitRequest.remarks);
        if (host2Json) {
            hostName2 = host2Json.hostName2;
            hostDepartmentName2 = host2Json.hostDepartmentName2;
        }
    }

    return (
        <Card>
            <CardHeader title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_REGISTER_STEP_HOST_INFO'})}/>
            <CardContent>
                <Descriptions>

                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_NAME'})}>
                        {props.visitRequest.hostFullName}
                    </DescriptionItem>
                    {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_STAFF_NUMBER'})}>*/}
                    {/*    {props.visitRequest.hostStaffNumber}*/}
                    {/*</DescriptionItem>*/}
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME'})}>
                        {props.visitRequest.hostDepartmentName}
                    </DescriptionItem>

                </Descriptions>
                <br/>
                <Descriptions>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_NAME_2ND'})}>
                        {hostName2}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_DEPARTMENT_2ND'})}>
                        {hostDepartmentName2}
                    </DescriptionItem>
                </Descriptions>
            </CardContent>
        </Card>
    );
};

export default VisitRequestHostInfo;
